import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';

const DEFAULT_CONTENT_SLOT = 'pcn-landing-page';

@Component({
  selector: 'epc-content-page',
  templateUrl: './content-page.component.html',
  styleUrls: ['./content-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContentPageComponent {
  public slotName$: Observable<string> = this.route.params.pipe(
    pluck('slotName'),
    map((slotName) => slotName ?? DEFAULT_CONTENT_SLOT),
  );
  public content$: Observable<string | null>;

  constructor(private route: ActivatedRoute) {}
}
